import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class registroVentaService {

    /******* QUERIES ******/

    async paginacion(filter) {
        
        const response = await axios
            .get(`${ERP}ventas/registro-venta/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async excel(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ple(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta/ple?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new registroVentaService();